import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import MapelService from '../../services/mapelServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('mapel/list', async (jenjangID, thunkAPI) => {
  try {
    const response = await MapelService.getList(jenjangID);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk('mapel/getListArchive', async (jenjangID, thunkAPI) => {
  try {
    const response = await MapelService.getListArchive(jenjangID);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('mapel/create', async ({ jenjangID, data }, thunkAPI) => {
  try {
    const response = await MapelService.create(jenjangID, data);
    thunkAPI.dispatch(getList(jenjangID));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const readData = createAsyncThunk('mapel/read', async ({ jenjangID, id }, thunkAPI) => {
  try {
    const response = await MapelService.read(jenjangID, id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('mapel/update', async ({ jenjangID, data }, thunkAPI) => {
  try {
    const response = await MapelService.update(jenjangID, data.id, data);
    thunkAPI.dispatch(getList(jenjangID));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteData = createAsyncThunk('mapel/delete', async ({ jenjangID, id }, thunkAPI) => {
  try {
    const response = await MapelService.del(jenjangID, id);
    thunkAPI.dispatch(getList(jenjangID));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeStatus = createAsyncThunk('mapel/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await MapelService.changeStatus(data.jenjangID, data.id, data);
    thunkAPI.dispatch(getList(data.jenjangID));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], data: [] };

const mapelSlice = createSlice({
  name: 'mapel',
  initialState,
  reducers: {
    clearList: (state) => {
      return {
        ...state,
        isLoading: true,
        list: []
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer, actions } = mapelSlice;
export const { clearList } = actions;

export default reducer;
